<template lang="pug">
    div.row.cf__addWords(v-if="$store.state.isUserLoggedIn")
        div.container.indent
            div.formBlock.wh_bl
                div.wrapper.wd
                    div.msg__success.is-active(v-if="success" v-html="success")
                    div.msg__error.is-active(v-if="errors" v-html="errors")
                    div.titleBlock.ml10.mb40 Редактирование слова
                        span «{{word.ru}}»
                        ul.date
                            li(v-if="word.updatedAt !== 'Invalid date'") Последнее обновления {{word.updatedAt}}
                            li(v-if="word.createdAt !== 'Invalid date'") Дата добавления {{word.createdAt}}

                    div.titleForm Слова
                    div.formGroup.wd33.send
                        label.label
                            div.name Русский
                            input.input(type='text', v-model="word.ru")
                        span.msg
                    div.formGroup.wd33.send
                        label.label
                            div.name Английский
                            input.input(type='text', v-model="word.en")
                        span.msg
                    div.formGroup.wd33.send
                        label.label
                            div.name Иврит
                            input.input(type='text', v-model="word.he")
                        span.msg
                    div.formGroup.wd50.send
                        label.label
                            div.name Джуури
                            input.input(type='text', v-model="word.lat")
                        span.msg
                    div.formGroup.wd50.send
                        label.label
                            div.name Джуури
                            input.input(type='text', v-model="word.cir")
                        span.msg


                    div.titleForm Пример использования
                    div.formGroup.wd33.send
                        label.label
                            div.name Русский
                            input.input(type='text', v-model="word.ruDesc")
                        span.msg
                    div.formGroup.wd33.send
                        label.label
                            div.name Английский
                            input.input(type='text', v-model="word.enDesc")
                        span.msg
                    div.formGroup.wd33.send
                        label.label
                            div.name Иврит
                            input.input(type='text', v-model="word.heDesc")
                        span.msg
                    div.formGroup.wd50.send
                        label.label
                            div.name Джуури
                            input.input(type='text', v-model="word.latDesc")
                        span.msg
                    div.formGroup.wd50.send
                        label.label
                            div.name Джуури
                            input.input(type='text', v-model="word.cirDesc")
                        span.msg
                    div.titleForm Похожие слова
                    div.formGroup.wd33.send
                        label.label
                            div.name Русский
                            input.input(type='text', v-model="word.sameWordsRu")
                        span.msg
                    div.formGroup.wd33.send
                        label.label
                            div.name Английский
                            input.input(type='text', v-model="word.sameWordsEn")
                        span.msg
                    div.formGroup.wd33.send
                        label.label
                            div.name Иврит
                            input.input(type='text', v-model="word.sameWordsHe")
                        span.msg
                    div.formGroup.wd50.send
                        label.label
                            div.name Джуури
                            input.input(type='text', v-model="word.sameWordsLat")
                        span.msg
                    div.formGroup.wd50.send
                        label.label
                            div.name Джуури
                            input.input(type='text', v-model="word.sameWordsCir")
                        span.msg

                    div.titleForm Настройки
                    label.controlCheckbox.wd50.ml15
                        input#checkbox.checkbox(type='checkbox', v-model='word.status', true-value='1', false-value='0', value='')
                        div.control__indicator
                        | Показать на сайте:
                        =' '
                        span(v-if="word.status == 1") да
                        span(v-else) нет

                    div.buttons.section.is-right.ml10.mr10
                        button.btn.btn_large.border.btnSaveWord(@click="save") Сохранить

</template>

<script>
    import {mapState} from 'vuex'
    import WordsService from '@/services/Words';

    export default {
        name: "words",
        data() {
            return {
                word: {
                    ru: '',
                    en: '',
                    he: '',
                    lat: '',
                    cir: '',
                    ruDesc: '',
                    enDesc: '',
                    heDesc: '',
                    latDesc: '',
                    cirDesc: '',
                    sameWordsRu: '',
                    sameWordsEn: '',
                    sameWordsHe: '',
                    sameWordsLat: '',
                    sameWordsCir: '',
                    soundJuhuri: '',
                    partSpeech: '',
                    status: '',
                    createdAt: '',
                    updatedAt: ''
                },
                success: null,
                errors: null,
                //required: (value) => !!value || 'Required.'
            }
        },
        methods: {
            scrollTop() {
                window.scrollTo(0, document.getElementsByTagName('body').offsetTop);
            },
            async save() {
                this.errors = null;
                const wordId = this.$store.state.route.params.id;
                if (!this.word.ru || !this.word.en || !this.word.he || !this.word.lat || !this.word.cir) {
                    this.scrollTop();
                    return this.errors = 'Пожалуйста, заполните поля.';
                }
                try {
                    await WordsService.update(this.word);
                    this.scrollTop();
                    this.success = 'Вы успешно обновили слово!';
                    setTimeout(() => {
                        this.success = null;
                    }, 2000);
                } catch (error) {
                    this.errors = error
                }
            }
        },
        computed: {
            ...mapState(['isUserLoggedIn']),
        },
        async mounted() {
            try {
                const wordId = this.$store.state.route.params.id;
                this.word = (await WordsService.getById(wordId)).data[0];
            } catch (error) {
                console.log(error)
            }
        },
    }
</script>

